import Toaster from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import Marketplace from "./pages/Marketplace";
import Profile from "./pages/Profile";
import UserProfile from "./pages/UserProfile";
import OfferDetails from "./pages/OfferDetails";
import CreateRequest from "./pages/CreateRequest";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import ResetPassword from "./pages/ResetPassword";
import Pricing from "./pages/Pricing";
import CreateOffer from "./pages/CreateOffer";
import CreateCustomPackage from "./pages/CreateCustomPackage";
import CustomPackages from "./pages/CustomPackages";
import CustomPackageDetail from "./pages/CustomPackageDetail";
import BuyerRequests from "./pages/BuyerRequests";
import Sellers from "./pages/Sellers";
import SellerDashboard from "./pages/SellerDashboard";
import Reviews from "./pages/Reviews";
import SellerProfile from "./pages/SellerProfile";
import RequestDetails from "./pages/RequestDetails";
import Settings from "./pages/Settings";
import SellerSettings from "./pages/settings/SellerSettings";
import ErrorBoundary from "./components/ErrorBoundary";
import SupabaseErrorBoundary from "./components/SupabaseErrorBoundary";
import ErrorPage from "./pages/ErrorPage";
import Dashboard from "./pages/Dashboard";
import { AuthProvider } from "./hooks/use-auth";
import { Suspense, lazy } from "react";
import ScrollRestoration from "./components/ScrollRestoration";
import PageLoading from "./components/PageLoading";
import AuthGuard from "./components/AuthGuard";
import PrivateRoute from "./components/PrivateRoute";

// Loading fallback for suspended components
const LoadingFallback = () => (
  <PageLoading />
);

const App = () => (
  <SupabaseErrorBoundary>
    <ErrorBoundary>
      <AuthProvider>
        <Toaster />
        <Sonner />
        <ScrollRestoration />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={
              <Suspense fallback={<LoadingFallback />}>
                <ErrorBoundary>
                  <Index />
                </ErrorBoundary>
              </Suspense>
            } />
            <Route path="/marketplace" element={<Marketplace />} />
            <Route path="/custom-packages" element={<CustomPackages />} />
            <Route path="/custom-packages/:idOrSlug" element={<CustomPackageDetail />} />
            <Route path="/custom-packages/:idOrSlug/purchase" element={<CustomPackageDetail />} />
            <Route path="/profile" element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            } />
            <Route path="/users/:userId" element={<UserProfile />} />
            <Route path="/offers/:offerId" element={<OfferDetails />} />
            <Route path="/buyer-requests" element={<BuyerRequests />} />
            <Route path="/buyer-requests/:requestId" element={<RequestDetails />} />
            <Route path="/create-request" element={
              <PrivateRoute>
                <CreateRequest />
              </PrivateRoute>
            } />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/create-offer" element={
              <PrivateRoute>
                <CreateOffer />
              </PrivateRoute>
            } />
            <Route path="/create-custom-package" element={
              <PrivateRoute>
                <CreateCustomPackage />
              </PrivateRoute>
            } />
            <Route path="/sellers" element={<Sellers />} />
            <Route path="/sellers/:sellerId" element={<SellerProfile />} />
            <Route path="/seller-dashboard" element={
              <PrivateRoute>
                <SellerDashboard />
              </PrivateRoute>
            } />
            <Route path="/dashboard" element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/settings" element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            } />
            <Route path="/settings/seller" element={
              <PrivateRoute>
                <SellerSettings />
              </PrivateRoute>
            } />
            <Route path="/error" element={<ErrorPage />} />
          </Route>
          
          <Route path="/login" element={
            <AuthGuard>
              <Login />
            </AuthGuard>
          } />
          <Route path="/signup" element={
            <AuthGuard>
              <Signup />
            </AuthGuard>
          } />
          <Route path="/reset-password" element={<ResetPassword />} />
          
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AuthProvider>
    </ErrorBoundary>
  </SupabaseErrorBoundary>
);

export default App;
